import {
  HRDashboard,
  AppSettings,
  CompanySettings,
  Department,
  Designation,
  DesignationAssign,
  Role,
  RoleAssign,
  OnBoarding,
  Employees,
  EmployeeDetails,
  EmployeeProfileDetails,
  Attendance,
  SalesAttendance,
  SalesVisitDetailsPage,
  UserTrips,
  TripDetails,
  MainAttendance,
  GeofenceManagement,
  FacialRecognitionApproval,
  AttendanceApprovals,
  AnomalyDashboard,
  EmployeePatternAnalysis,
  CrashlyticsDashboard,
  Leaves,
  LeaveApproval,
  ApplyForLeaves,
  LeaveBalance,
  ExpensesList,
  ApplyForExpense,
  ExpensesApproval,
  ExpensePayout,
  PettyCash,

  LoanApprovals,
  DailyUpdatesForm,
  OverallUpdates,
  EmployeesSalaryPayroll,
  CreateEmployeeSalarySlip,
  ViewAllSlipsList,
  ViewSalarySlip,
  SalaryPaidReport,
  Resume,
  ResumeDetails,
  PublicResumeSubmissionForm,
  CandidateInterview,
  InterviewRecordings,
  InterviewManagement,
  EmployeeOnboarding,
  ContactForm,
  Notification,
  FeedbackManagement,
  HelpSupport,
  MyTickets,
  AllTickets,
  CreateTicket,
  TicketDetails,
  UserTicketDetails,
  Engage,
  EmailManagement,
  DefaultCalendar,
  MonthGrid,
  MultiMonthStack,
  Notes,
  // Performance Review
  PerformanceReviewDashboard,
  ReviewTemplates,
  SelfReview,
  MyReviews,
  CreateReviewCycle,
  ManagerReviews,
  ManagerReviewDetail,
  AdminReviews,
  AdminReviewDetail,
  ReviewHistory,
  ReviewAnalytics,
  ReviewDetailView,
  // Weekly Learning
  WeeklyLearningForm,
  // Module Assignment
  ModuleAssignment,
  ModuleManagement,
  QRCodeGenerator,
  // Search
  SearchPage,
  // PDF to CSV
  PdfToCsv,
  // Tenant Management
  TenantManagement,
  TenantRegistration,
  // Employee Assets Management
  EmployeeAssetsManagement,
  AssetForm,
  AssetDetails,
  // Invoices
  InvoiceListView,
  InvoiceAddNew,
  InvoiceOverview,
  // Authentication
  Login,
  ResetPassword,
  Verification,
  Logout,
  Register,
  VerifyEmail,
  UserProfile,
  // Pages
  Account,
  Settings,
  Pricing,
  Faqs,
  ContactUs,
  // Events
  CertificateDownloadPage,
  InternOfTheMonthReveal,
  CyberGuard2026EventPage,

} from './lazyRoutes';

// Auth protected routes - using lazy-loaded components
export const authProtectedRoutes = [
  // Dashboard - Single route for all roles
  { path: "/dashboard", component: HRDashboard },

  // App Settings - Super Admin only
  { path: "/app-settings", component: AppSettings },
  
  { path: "/notifications", component: Notification },

  { path: "/company-settings", component: CompanySettings },
  { path: "/companies", component: CompanySettings },

  { path: "/departments", component: Department },

  { path: "/designations", component: Designation },
  { path: "/designations/assign", component: DesignationAssign },

  { path: "/roles", component: Role },
  { path: "/roles/assign", component: RoleAssign },

  { path: "/onboarding", component: OnBoarding },
  { path: "/employees", component: Employees },
  { path: "/employees/:employeeId/details", component: EmployeeDetails },
  { path: "/employees/profile", component: EmployeeProfileDetails },

  { path: "/attendance", component: Attendance },
  { path: "/attendance/sales-executives", component: SalesAttendance },
  { path: "/travel/:visitId/details", component: SalesVisitDetailsPage },
  { path: "/trip/:tripId/details", component: TripDetails },
  { path: "/attendance/user-trips/:userId", component: UserTrips },
  { path: "/personal-trips", component: UserTrips },
  { path: "/personal-trips/:userId", component: UserTrips },
  { path: "/attendance/all", component: MainAttendance },
  { path: "/geofence-management", component: GeofenceManagement },
  { path: "/facial-recognition-approval", component: FacialRecognitionApproval },
  { path: "/attendance-approvals", component: AttendanceApprovals },

  // Anomaly Detection
  { path: "/anomaly-detection", component: AnomalyDashboard },
  { path: "/anomaly-detection/employee/:employeeId/patterns", component: EmployeePatternAnalysis },

  // Crashlytics
  { path: "/crashlytics", component: CrashlyticsDashboard },

  { path: "/leaves", component: Leaves },
  { path: "/leave-approvals", component: LeaveApproval },
  { path: "/apply-for-leaves", component: ApplyForLeaves },
  { path: "/leave-balance", component: LeaveBalance },

  { path: "/expenses", component: ExpensesList },
  { path: "/apply-for-expense", component: ApplyForExpense },
  { path: "/expense-approvals", component: ExpensesApproval },
  { path: "/expense-payout", component: ExpensePayout },


  // Petty Cash Management
  { path: "/petty-cash", component: PettyCash },



  { path: "/daily-updates-form", component: DailyUpdatesForm },
  { path: "/overall-updates", component: OverallUpdates },

  { path: "/payroll", component: EmployeesSalaryPayroll },
  { path: "/payroll/salary-paid-report", component: SalaryPaidReport },
  { path: "/payroll/:employeeId/generate/slip", component: CreateEmployeeSalarySlip },
  { path: "/payroll/:employeeId/view/slips", component: ViewAllSlipsList },
  { path: "/payroll/:employeeId/month/salaryslip", component: ViewSalarySlip },

  { path: "/loan-approvals", component: LoanApprovals },

  { path: "/resumes", component: Resume },
  { path: "/resume-details", component: ResumeDetails },
  { path: "/interviews", component: InterviewManagement },
  { path: "/interview-recordings", component: InterviewRecordings },

  { path: "/contact-form-entries", component: ContactForm },

  { path: "/feedback-management", component: FeedbackManagement },

  // Help & Support
  { path: "/help-support", component: HelpSupport },

  // Tickets
  { path: "/my-tickets", component: MyTickets },
  { path: "/all-tickets", component: AllTickets },
  { path: "/create-ticket", component: CreateTicket },
  { path: "/ticket/:ticketId", component: TicketDetails },
  { path: "/my-ticket/:ticketId", component: UserTicketDetails },

  // Engage
  { path: "/apps-engage", component: Engage },

  // Email Management
  { path: "/email", component: EmailManagement },

  // Calendar
  { path: "/apps-calendar", component: DefaultCalendar },
  { path: "/apps-calendar-month-grid", component: MonthGrid },
  { path: "/apps-calendar-multi-month-stack", component: MultiMonthStack },

  // Notes
  { path: "/apps-notes", component: Notes },

  // Performance Review
  { path: "/performance-review", component: PerformanceReviewDashboard },
  { path: "/performance-review/templates", component: ReviewTemplates },
  { path: "/performance-review/create-cycle", component: CreateReviewCycle },
  { path: "/performance-review/self-review/:reviewId", component: SelfReview },
  { path: "/performance-review/my-reviews", component: MyReviews },
  { path: "/performance-review/manager-reviews", component: ManagerReviews },
  { path: "/performance-review/manager-review/:reviewId", component: ManagerReviewDetail },
  { path: "/performance-review/admin-reviews", component: AdminReviews },
  { path: "/performance-review/admin-review/:reviewId", component: AdminReviewDetail },
  { path: "/performance-review/history", component: ReviewHistory },
  { path: "/performance-review/analytics", component: ReviewAnalytics },
  { path: "/performance-review/review/:reviewId", component: ReviewDetailView },

  // Weekly Learning Submission
  { path: "/weekly-learning-submission", component: WeeklyLearningForm },

  // Module Assignment
  { path: "/module-assignment", component: ModuleAssignment },
  { path: "/module-management", component: ModuleManagement },
  { path: "/qr-code-generator", component: QRCodeGenerator },

  // Search
  { path: "/search", component: SearchPage },

  // PDF to CSV
  { path: "/pdf-to-csv", component: PdfToCsv },

  // Tenant Management
  { path: "/tenant-management", component: TenantManagement },
  { path: "/tenant-registration", component: TenantRegistration },

  // Employee Assets Management
  { path: "/employee-assets", component: EmployeeAssetsManagement },
  { path: "/employee-assets/add", component: AssetForm },
  { path: "/employee-assets/edit/:id", component: AssetForm },
  { path: "/employee-assets/details/:id", component: AssetDetails },

  // Invoices
  { path: "/apps-invoice-list", component: InvoiceListView },
  { path: "/apps-invoice-add-new", component: InvoiceAddNew },
  { path: "/apps-invoice-overview", component: InvoiceOverview },

  // pages
  { path: "/pages-account", component: Account },
  { path: "/pages-account-settings", component: Settings },
  { path: "/pages-pricing", component: Pricing },
  { path: "/pages-faqs", component: Faqs },
  { path: "/pages-contact-us", component: ContactUs },

  // profile
  { path: "/user-profile", component: UserProfile },
  

];

// Public routes
export const publicRoutes = [
  // Public Resume Submission
  { path: "/apply", component: PublicResumeSubmissionForm },

  // Event certificate download (25 Feb 2026) - name-based, no backend
  { path: "/events/25-feb-2026/certificate/:certType", component: CertificateDownloadPage },

  // Intern of the Month reveal (curtain animation)
  { path: "/events/intern-of-the-month", component: InternOfTheMonthReveal },

  // Cyber Guard 2026 – event details (no certificate download)
  { path: "/events/cyber-guard-2026", component: CyberGuard2026EventPage },

  // Candidate Interview (public with token)
  { path: "/interview", component: CandidateInterview },

  // Employee Onboarding
  { path: "/employee-onboarding", component: EmployeeOnboarding },

  // authentication
  { path: "/login", component: Login },
  { path: "/reset-password", component: ResetPassword },
  { path: "/reset-password/verify", component: Verification },
  { path: "/logout", component: Logout },
  { path: "/register", component: Register },
  { path: "/verify-email", component: VerifyEmail },
];
